export default "__VITE_ASSET__7d29077d__"